__turbopack_context__.v({
  "avatar": "skeleton-module__Cuawza__avatar",
  "button": "skeleton-module__Cuawza__button",
  "heading": "skeleton-module__Cuawza__heading",
  "shimmer": "skeleton-module__Cuawza__shimmer",
  "skeleton": "skeleton-module__Cuawza__skeleton",
  "text": "skeleton-module__Cuawza__text",
  "textSm": "skeleton-module__Cuawza__textSm",
  "thumb": "skeleton-module__Cuawza__thumb",
});
